import React from 'react';
import AnalyticsChartSegment from './AnalyticsChartSegment';
import AnalyticsSummaryBlock from './AnalyticsSummaryBlock';

function AnalyticsLayout({
  summaryData,
  statistics,
  auctionsDataTotal,
  bidsDataTotal,
  auctionsData,
  bidData,
  soldCount,
  wonCount,
  showAuctionsChart = true,
  showBidsChart = true,
}) {
  return (
    <div className="analytics-content">
      <div className="analytics-content-summary">
        {summaryData.length > 0 && (
          <div className="analytics-content-summary-wrapper">
            {summaryData
              .slice(0, Math.min(2, summaryData.length))
              .map(({ title, key, prefix }) => (
                <AnalyticsSummaryBlock
                  key={key}
                  title={title}
                  value={statistics?.[key] ?? 0}
                  prefix={prefix}
                />
              ))}
          </div>
        )}
        {summaryData.length > 2 && (
          <div className="analytics-content-summary-wrapper">
            {summaryData.slice(2, 4).map(({ title, key, prefix }) => (
              <AnalyticsSummaryBlock
                key={key}
                title={title}
                value={statistics?.[key] ?? 0}
                prefix={prefix}
              />
            ))}
          </div>
        )}
      </div>

      <div className="analytics-content-wrapper">
        {showAuctionsChart && (
          <div className="analytics-content-column">
            <AnalyticsChartSegment
              title="Launched Auctions"
              total={auctionsDataTotal}
              count={soldCount}
              label="Sold"
              data={auctionsData}
            />
          </div>
        )}
        {showBidsChart && (
          <div className="analytics-content-column">
            <AnalyticsChartSegment
              title="Placed Bids"
              total={bidsDataTotal}
              count={wonCount}
              label="Won"
              data={bidData}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AnalyticsLayout;
